module.exports = __webpack_public_path__ + "static/img/4.b493f08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/4.png
// module id = /umN
// module chunks = 0